<template>
  <div class="dsf_teas_learning_main">
    <div class="dsf_teas_learning_date">
      <div @click="reduce" class="icon-b"><van-icon name="arrow-left" /></div>
      <div class="title">{{ weekName }}</div>
      <div @click="add" class="icon-b"><van-icon name="arrow" /></div>
    </div>
    <div class="dsf_teas_learning_scroll_box">
      <dsf-mobile-teas-schedule-list
        :url="urlOfflineShift"
        :is-design="isDesign"
        @dialogRowClick="dialogRowClick"
      />
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasNewLearningSchedule",
  ctrlCaption: "在学日程",
  mixins: [$mixins.control],
  design: {
    isMask: false,
  },
  props: {
    url: {
      type: String,
      default: "teas/schedule/course/arrange/getStuCourseByTime",
    },
    classIdString: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      urlOfflineShift: "",
      dayWeek: [],
      weekNum: 0,
      currentDate: "",
      classId: "",
    };
  },
  computed: {
    weekName() {
      if (this.dayWeek.length == 0) {
        return "";
      }
      return `${dsf.date.format(
        new Date(this.dayWeek[0]),
        "m月d日"
      )} - ${dsf.date.format(
        new Date(this.dayWeek[this.dayWeek.length - 1]),
        "m月d日"
      )}`;
    },
    weekRange() {
      if (!this.dayWeek.length) {
        return [null, null];
      }
      return [
        dsf.date.format(this.dayWeek[0], "yyyy-mm-dd"),
        dsf.date.format(this.dayWeek[this.dayWeek.length - 1], "yyyy-mm-dd"),
      ];
    },
  },
  watch: {
    weekName() {
      this.updateUrl();
    },
    url() {
      this.updateUrl();
    },
  },
  created() {
    if(this.classIdString.length > 0){
      this.classId = this.classIdString;
    }else{
      this.classId = this.queryString.classId || "";
    }
    let tempChangeDate = localStorage.getItem("changeDate");
    localStorage.removeItem("changeDate");
    if(tempChangeDate){
      this.currentDate = new Date(tempChangeDate);
    }
    else{
      if(this.currentDate == ""){
        this.currentDate = new Date();
      }
    }
    this.dayWeek = this.getWeekTime(this.currentDate);
    this.updateUrl();
  },
  activated(){
    let tempChangeDate = localStorage.getItem("changeDate");
    localStorage.removeItem("changeDate");
    if(tempChangeDate){
      this.currentDate = new Date(tempChangeDate);
    }
    else{
      if(this.currentDate == ""){
        this.currentDate = new Date();
      }
    }
    this.dayWeek = this.getWeekTime(this.currentDate);
    this.updateUrl();
  },
  methods: {
    updateUrl() {
      let url = this.url;
      if (url && url != "") {
        url += url.indexOf("?") == -1 ? "?" : "&";
        url += `isnum=false&stime=${this.weekRange[0]} 00:00:00&etime=${this.weekRange[1]} 23:59:59`;
        if(this.classId.length > 0){
            url += `&classId=${this.classId}`
        }
        this.urlOfflineShift = url;
      } else {
        this.urlOfflineShift = null;
      }
    },
    reduce() {
      if (this.$listeners["reduceWeek"]) {
        this.$dispatch("reduceWeek", {});
        return;
      }
      this.weekNum--;
      this.currentDate = this.dsf.date.parse(this.fun_date(this.currentDate,-7),'yyyy/mm/dd')
      this.dayWeek = this.getWeekTime(this.currentDate);
    },
    add() {
      if (this.$listeners["addWeek"]) {
        this.$dispatch("addWeek", {});
        return;
      }
      this.weekNum++;
      this.currentDate = this.dsf.date.parse(this.fun_date(this.currentDate,7),'yyyy/mm/dd')
      this.dayWeek = this.getWeekTime(this.currentDate);
    },
    getWeekTime(day) {
      let w = (day.getDay() || 7) - 1;
      let arr = [];
      //星期一开始
      for (let i = 0; i < 7; i++) {
        let d = new Date(day.getTime());
        d.setDate(d.getDate() + i - w);
        arr.push(dsf.date.format(d, 'yyyy/mm/dd'));
      }
      return arr;
    },
    fun_date(date,number){
      var date1 = date;
      var date2 = new Date(date1);
      date2.setDate(date1.getDate()+number);
      var time2 = date2.getFullYear()+"-"+(date2.getMonth()+1)+"-"+date2.getDate();
      return time2;
    },
    dialogRowClick(args){
      if (this.$listeners["dialogLineClick"]) {
        this.$dispatch("dialogLineClick", args);
      }
    }
  },
});
</script>
